import { ElementRef, NgZone } from '@angular/core';
import { platformIconPath } from '../../../../app.constants';
import { InfluencerPost } from '../../../../../models/influencer';
import { UserService } from '../../../../services/user.service';
var PostImageComponent = /** @class */ (function () {
    function PostImageComponent(_ngZone, _userService) {
        this._ngZone = _ngZone;
        this._userService = _userService;
        this.youtubeImageRadio = 94 / 168;
    }
    PostImageComponent.prototype.ngOnInit = function () {
    };
    PostImageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._ngZone.runOutsideAngular(function () {
            if (!_this.post || !_this.postImageContainer) {
                return;
            }
            var containerWidth = _this.postImageContainer.nativeElement.clientWidth;
            if (_this.post.platformId === platformIconPath.youtube.id) {
                _this.postImageContainer.nativeElement.style.height = Math.floor(containerWidth * _this.youtubeImageRadio) + 'px';
            }
            else {
                var imageWidth = _this.post.imageWidth > 0 ? _this.post.imageWidth : _this.post.mediaWidth > 0 ? _this.post.mediaWidth : 0;
                var imageHeight = _this.post.imageHeight > 0 ? _this.post.imageHeight : _this.post.mediaHeight > 0 ? _this.post.mediaHeight : 0;
                if (imageWidth > 0 && imageHeight > 0) {
                    _this.postImageContainer.nativeElement.style.height = Math.floor((containerWidth * imageHeight) / imageWidth) + 'px';
                }
                else {
                    _this.postImageContainer.nativeElement.style.height = Math.floor(containerWidth * 1.25) + 'px';
                }
            }
        });
    };
    PostImageComponent.prototype.onLoadedImage = function () {
        var postImageContainer = this.postImage.nativeElement.parentElement;
        postImageContainer.classList.add('is-loaded');
    };
    PostImageComponent.prototype.onLoadImageError = function () {
        var postImageContainer = this.postImage.nativeElement.parentElement;
        postImageContainer.classList.add('is-error');
    };
    PostImageComponent.prototype.hasDimension = function (post) {
        return post && ((post.imageHeight > 0 && post.imageWidth > 0) || (post.mediaHeight > 0 && post.mediaWidth > 0));
    };
    Object.defineProperty(PostImageComponent.prototype, "activeAccount", {
        get: function () {
            return this._userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    return PostImageComponent;
}());
export { PostImageComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/post-image/post-image.component.ts.pre-build-optimizer.js